import * as actions from "./actionsTypes";

const initialData = {
    loaderNotifications: false,
    notifications: null,
    notificationsFail: null,
    saveLoaderNotifications: false,
    notificationsFormError: null
};

export default function NotificationsReducer(state = initialData, action) {
    switch (action.type) {
        case actions.LOADING_NOTIFICATIONS:
            return { ...state, loaderNotifications: action.payload };

        case actions.GET_NOTIFICATIONS:
            return { ...state, notifications: action.payload };

        case actions.NOTIFICATIONS_FAIL:
            return { ...state, notificationsFail: action.payload };

        case actions.SAVE_LOADING_NOTIFICATIONS:
            return { ...state, saveLoaderNotifications: action.payload };

        case actions.FORM_NOTIFICATIONS_FAIL:
            return { ...state, notificationsFormError: action.payload };

        default:
            return state;
    }
}
